import React, { useState, useEffect } from "react";
import Icon from "./icon";
import { mdiWindowClose } from "@mdi/js";

const sizeClasses = {
  sm: "max-w-sm",   // ~24rem
  md: "max-w-lg",   // ~32rem
  lg: "max-w-2xl",  // ~42rem
  xl: "max-w-5xl",  // ~80rem
  full: "max-w-[95vw]" // almost full width
};

const Modal = ({ show, title, onClose, children, size = "md" }) => {
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    setIsVisible(show);
  }, [show]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div
        className={`bg-white rounded-2xl shadow-2xl w-full ${sizeClasses[size]} mx-auto p-8 max-h-[95vh] overflow-y-auto relative`}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-6">
          <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 transition-colors"
          >
            <Icon path={mdiWindowClose} size={1.5} />
          </button>
        </div>

        {/* Body */}
        <div className="flex flex-col gap-6">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
